import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import type { OmitStylesComponentProps } from '../../types';

const sliderVariants = cva(
    'rocco-slider relative flex w-full touch-none select-none items-center',
    {
        variants: {
            variant: {
                default: '',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export const Slider = React.forwardRef<
    React.ElementRef<typeof SliderPrimitive.Root>,
    OmitStylesComponentProps<typeof SliderPrimitive.Root> &
        VariantProps<typeof sliderVariants>
>(({ variant, ...props }, ref) => (
    <SliderPrimitive.Root
        ref={ref}
        className={sliderVariants({ variant })}
        {...props}
    >
        <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-gray-50">
            <SliderPrimitive.Range className="absolute h-full bg-gray-900" />
        </SliderPrimitive.Track>

        {props.value?.map((value, index) => (
            <SliderPrimitive.Thumb
                key={index}
                className="block h-6 w-6 rounded-full bg-gray-900 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
            />
        )) ?? null}
    </SliderPrimitive.Root>
));

Slider.displayName = 'Slider';
